import { useEffect, useState, type FormEvent } from "react";
import type { PunchResult } from "@platform/contracts";
import { api } from "../api";
import { BrandMark } from "./BrandMark";

export function PunchPage() {
  const [identification, setIdentification] = useState("");
  const [result, setResult] = useState<PunchResult | null>(null);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [clock, setClock] = useState(() => new Date());
  useEffect(() => { const timer = window.setInterval(() => setClock(new Date()), 1000); return () => window.clearInterval(timer); }, []);
  useEffect(() => { if (!result) return; const timer = window.setTimeout(() => setResult(null), 8000); return () => window.clearTimeout(timer); }, [result]);

  async function submit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault(); setError(""); setResult(null); setSubmitting(true);
    try { setResult(await api.punch(identification)); setIdentification(""); }
    catch (cause) { setError(cause instanceof Error ? cause.message : "Unable to record your punch"); }
    finally { setSubmitting(false); }
  }

  return <main className="punch-page">
    <header><BrandMark/><div className="punch-clock"><strong>{clock.toLocaleTimeString()}</strong><span>{clock.toLocaleDateString(undefined, { weekday: "long", day: "numeric", month: "long", year: "numeric" })}</span></div></header>
    <section className="punch-card">
      <h1>Attendance terminal</h1>
      <p>Enter your identification number to punch in. Enter it again at the end of your shift to punch out.</p>
      <form onSubmit={submit}>
        <label htmlFor="identification">Identification number</label>
        <input id="identification" value={identification} onChange={(event) => setIdentification(event.target.value)} placeholder="e.g. SK-1042" autoComplete="off" autoFocus inputMode="text" required/>
        <button className="primary-button" disabled={submitting || !identification.trim()}>{submitting ? "Recording…" : "Punch in / out"}</button>
      </form>
      {error && <div className="form-error" role="alert">{error}</div>}
      {result && <div className={`punch-result ${result.action}`} role="status">
        <strong>{result.action === "in" ? "Punched in" : "Punched out"}</strong>
        <span className="punch-name">{result.displayName}</span>
        <span>{result.role.replaceAll("_", " ")} · {new Date(`${result.at}Z`).toLocaleTimeString()}</span>
        {result.action === "out" && result.sessionStartedAt && <span className="punch-duration">Shift started {new Date(`${result.sessionStartedAt}Z`).toLocaleTimeString()} · {shiftLength(result.sessionStartedAt, result.at)}</span>}
      </div>}
    </section>
    <footer>Talahwa attendance · this terminal records time only</footer>
  </main>;
}

function shiftLength(start: string, end: string): string {
  const minutes = Math.max(0, Math.round((new Date(`${end}Z`).getTime() - new Date(`${start}Z`).getTime()) / 60000));
  return `${Math.floor(minutes / 60)}h ${String(minutes % 60).padStart(2, "0")}m`;
}
